import GoogleGeoCoderResponse from '../../../globalTypes/GoogleGeoCoderResponse';
var GoogleGeoCoder = /** @class */ (function () {
    //private googlePromise: Promise<object>;
    function GoogleGeoCoder() {
        /*
        const src = document.createElement('script');
        src.src = 's';
        src.async = false;

        const head = document.head || document.getElementsByTagName('head')[0];
        head.insertBefore(src, head.firstChild);
        this.googlePromise = new Promise((resolve, reject) => {
            src.addEventListener('load', () => {
                // @ts-ignore
                if (typeof window.google !== 'undefined') {
                    // @ts-ignore
                    resolve(window.google);
                }
                reject();
            });
            src.addEventListener('error', () => {
                reject();
            })
        });
        */
    }
    GoogleGeoCoder.getInstance = function () {
        if (GoogleGeoCoder.instance !== null) {
            return GoogleGeoCoder.instance;
        }
        return GoogleGeoCoder.instance = new GoogleGeoCoder();
    };
    GoogleGeoCoder.prototype.encode = function (country, postCode, name) {
        //const google:object = await this.googlePromise;
        var response = new Promise(function (resolve, reject) {
            // @ts-ignore
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: country + ',' + postCode }, function (results, status) {
                // @ts-ignore
                var stateOk = status === google.maps.GeocoderStatus.OK;
                var googleGeoCoderResponse = new GoogleGeoCoderResponse(stateOk ? 'OK' : 'NO', name);
                if (stateOk) {
                    var filteredArrayPlz = results[0].address_components.filter(function (addressComponent) {
                        return addressComponent.types.includes('postal_code');
                    });
                    var plz = filteredArrayPlz.length ? filteredArrayPlz[0].long_name : '';
                    if (plz === postCode) {
                        if (typeof (results[0].postcode_localities) === 'object') {
                            for (var _i = 0, _a = results[0].postcode_localities; _i < _a.length; _i++) {
                                var _b = _a[_i], key = _b[0], value = _b[1];
                                googleGeoCoderResponse.addCity(key, value);
                            }
                        }
                        else {
                            var filteredArray = results[0].address_components.filter(function (addressCmponent) {
                                return addressCmponent.types.includes('locality');
                            });
                            var placeName = filteredArray.length ? filteredArray[0].long_name : '';
                            if (placeName !== '' && postCode !== '') {
                                googleGeoCoderResponse.addCity(postCode, placeName);
                            }
                        }
                        resolve(googleGeoCoderResponse);
                    }
                }
                reject(false);
            });
        });
        return response;
    };
    GoogleGeoCoder.instance = null;
    return GoogleGeoCoder;
}());
export { GoogleGeoCoder };
